"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wechat;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.promise");

var _config = require("../config");

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var xhr = _utils.default.xhr;

function addWxScript() {
  var jsUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.WECHAT.wxJsUrl;
  return new Promise(function (resolve) {
    var script = document.getElementById('wxJsUrl');

    if (!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'wxJsUrl';
      script.src = jsUrl;
      document.body.appendChild(script);

      script.onload = function () {
        resolve();
      };
    } else {
      resolve();
    }
  });
}

function wechatDidMount() {
  var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.WECHAT.appId;
  var apiList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config.WECHAT.apiList;
  var ticketApi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config.WECHAT.ticketApi;
  var authUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.location.href;
  return new Promise(function (resolve, reject) {
    xhr(ticketApi, {
      url: authUrl
    }).then(function (resp) {
      var _resp$content = resp.content,
          timestamp = _resp$content.timestamp,
          nonceStr = _resp$content.nonceStr,
          signature = _resp$content.signature;
      var wx = window.wx;

      var jsApiList = _toConsumableArray(apiList);

      wx.config({
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: jsApiList
      });
      wx.ready(function () {
        resolve();
      });
    }, reject);
  });
}

function internalShare(config) {
  var wx = window.wx;
  var title = config.title,
      link = config.link,
      desc = config.desc,
      imgUrl = config.imgUrl,
      _success = config.success,
      _error = config.error;

  if (!title) {
    return;
  }

  _config.WECHAT.apiList.forEach(function (item) {
    wx[item]({
      title: title,
      link: link || window.location.href,
      desc: desc,
      imgUrl: imgUrl,
      success: function success() {
        _success && _success({
          platform: item
        });
      },
      error: function error() {
        _error && _error({
          platform: item
        });
      }
    });
  });
}
/**
 * 微信公众号初始化
 * 入参:
 *  {String} title：分享标题
 *  {String} desc：分享描述
 *  {String} imgUrl：分享图标
 *  {String} link：分享链接
 *  {Function} error：分享取消
 *  {Function} success：分享成功
 *  {String} appId：公众号id
 *  {Array} apiList：需要授权的api
 *  {String} ticketApi：获取config签名api
 *  {String} wxJsUrl：公众号js路径
 *  {String} authUrl：公众号授权的url
 */


function wechat(_x) {
  return _wechat.apply(this, arguments);
}

function _wechat() {
  _wechat = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(opts) {
    var appId, apiList, ticketApi, wxJsUrl, authUrl;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appId = opts.appId, apiList = opts.apiList, ticketApi = opts.ticketApi, wxJsUrl = opts.wxJsUrl, authUrl = opts.authUrl;
            opts.link = opts.link || window.location.href;
            _context.next = 4;
            return addWxScript(wxJsUrl);

          case 4:
            _context.next = 6;
            return wechatDidMount(appId, apiList, ticketApi, authUrl);

          case 6:
            internalShare(opts);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _wechat.apply(this, arguments);
}